module.exports = __webpack_public_path__ + "img/unknown.e8e7cc7f.webp";